import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLang } from '../../contexts/LangContext';
import { supabase } from '../../lib/supabase';
import PasswordInput from '../../components/PasswordInput';

export default function LoginPage() {
  const { login, loginDemo, isLocalDev } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang, setLang } = useLang();
  const [modo, setModo] = useState('login'); // 'login' | 'recuperar'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [recEmail, setRecEmail] = useState('');
  const [recMsg, setRecMsg] = useState(null);
  const [recLoading, setRecLoading] = useState(false);
  const nextParam = new URLSearchParams(location.search).get('next');
  const safeNext = nextParam && nextParam.startsWith('/') && !nextParam.startsWith('//') ? nextParam : null;
  const redirectTo = safeNext || location.state?.from;

  const tx = {
    pt: {
      subtitle: 'Área restrita — faça login para continuar', email: 'Email', senha: 'Senha', entrar: 'Entrar', entrando: 'Entrando...',
      esqueciSenha: 'Esqueci minha senha', recSubtitle: 'Informe seu email e enviaremos um link para redefinir sua senha.',
      enviarLink: 'Enviar link de recuperação', enviando: 'Enviando...', voltarLogin: '← Voltar para o login',
      recSucesso: 'Se esse email estiver cadastrado, você vai receber um link de recuperação em instantes.',
    },
    en: {
      subtitle: 'Restricted area — sign in to continue', email: 'Email', senha: 'Password', entrar: 'Sign in', entrando: 'Signing in...',
      esqueciSenha: 'Forgot my password', recSubtitle: "Enter your email and we'll send you a link to reset your password.",
      enviarLink: 'Send recovery link', enviando: 'Sending...', voltarLogin: '← Back to login',
      recSucesso: "If that email is registered, you'll receive a recovery link shortly.",
    },
  }[lang];

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (result.success) navigate(redirectTo || (result.user.role === 'aluna' ? '/aluna/hoje' : '/admin'), { replace: true });
    else setError(result.error);
  }

  async function handleDemo(role) {
    setError('');
    const result = await loginDemo(role);
    if (result.success) navigate(redirectTo || (result.user.role === 'aluna' ? '/aluna/hoje' : '/admin'), { replace: true });
    else setError(result.error);
  }

  async function handleRecuperar(e) {
    e.preventDefault();
    setRecMsg(null); setRecLoading(true);
    await supabase.auth.resetPasswordForEmail(recEmail, {
      redirectTo: `${window.location.origin}/redefinir-senha`,
    });
    setRecLoading(false);
    setRecMsg(tx.recSucesso);
  }

  return (
    <div className="lp-page">
      <style>{`
        .lp-page { min-height:100vh; background:var(--surface-2); display:flex; align-items:center; justify-content:center; padding:20px; }
        .lp-card { width:100%; max-width:400px; background:var(--bg); padding:48px 40px; box-shadow:0 4px 32px rgba(37,28,25,0.1); border-radius:var(--r-card); }
        .lp-input { width:100%; padding:11px 13px; border:1.5px solid var(--divider); border-radius:var(--r-input); font-size:14px; color:var(--text); background:var(--surface); outline:none; margin-bottom:16px; font-family:'Inter',sans-serif; transition:border-color 0.2s; box-sizing:border-box; }
        .lp-input:focus { border-color:var(--accent); }
        .lp-btn { width:100%; padding:13px; background:var(--accent); color:var(--btn-text); border:none; border-radius:var(--r-btn); font-size:13px; font-weight:600; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; transition:background 0.2s; font-family:'Inter',sans-serif; margin-top:4px; }
        .lp-btn:hover { background:var(--accent-hover); }
        .lp-label { display:block; font-size:10px; font-weight:700; letter-spacing:0.1em; text-transform:uppercase; color:var(--text-3); margin-bottom:5px; }
        @media(max-width:480px){
          .lp-page{ min-height:100svh; align-items:center; justify-content:center; padding:0; background:var(--bg); overflow-x:hidden; }
          .lp-card{ width:100%; min-height:100svh; border-radius:0; box-shadow:none; padding:max(28px, env(safe-area-inset-top)) 28px max(28px, env(safe-area-inset-bottom)); display:flex; flex-direction:column; justify-content:center; box-sizing:border-box; }
          .lp-card > div:first-of-type{ margin-bottom:22px !important; }
          .lp-card > div:nth-of-type(2){ margin-bottom:26px !important; }
        }
        @media(max-width:480px) and (max-height:650px){
          .lp-page{ align-items:flex-start; overflow-y:auto; }
          .lp-card{ justify-content:flex-start; min-height:100dvh; padding-top:max(20px, env(safe-area-inset-top)); padding-bottom:max(24px, env(safe-area-inset-bottom)); }
        }
      `}</style>
      <div className="lp-card">

        {/* Seletor de idioma */}
        <div style={{ display:'flex', justifyContent:'center', gap:'6px', marginBottom:'28px' }}>
          <button onClick={() => setLang('pt')} style={{ padding:'5px 14px', border:`1.5px solid ${lang==='pt' ? 'var(--text)' : 'var(--divider)'}`, borderRadius:'var(--r-btn)', background: lang==='pt' ? 'var(--text)' : 'transparent', color: lang==='pt' ? '#FAF7F2' : 'var(--text-2)', fontSize:'11px', fontWeight:600, cursor:'pointer', letterSpacing:'0.06em', fontFamily:"'Inter',sans-serif" }}>🇧🇷 PT</button>
          <button onClick={() => setLang('en')} style={{ padding:'5px 14px', border:`1.5px solid ${lang==='en' ? 'var(--text)' : 'var(--divider)'}`, borderRadius:'var(--r-btn)', background: lang==='en' ? 'var(--text)' : 'transparent', color: lang==='en' ? '#FAF7F2' : 'var(--text-2)', fontSize:'11px', fontWeight:600, cursor:'pointer', letterSpacing:'0.06em', fontFamily:"'Inter',sans-serif" }}>🇺🇸 EN</button>
        </div>

        <div style={{ textAlign:'center', marginBottom:'32px' }}>
          <img src="/logo.svg" alt="Team Carol Macedo" style={{ height:'48px', width:'auto', objectFit:'contain' }} />
        </div>

        {modo === 'login' && (
          <div style={{ fontSize:'13px', color:'var(--text-2)', marginBottom:'28px', textAlign:'center', letterSpacing:'0.02em' }}>
            {tx.subtitle}
          </div>
        )}

        {modo === 'login' ? (
          <>
            {error && (
              <div style={{ padding:'11px 13px', background:'rgba(229,57,53,0.07)', border:'1px solid rgba(229,57,53,0.2)', color:'#C62828', borderRadius:'var(--r-btn)', fontSize:'13px', marginBottom:'16px' }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <label className="lp-label">{tx.email}</label>
              <input className="lp-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="seu@email.com" required />
              <label className="lp-label">{tx.senha}</label>
              <PasswordInput
                className="lp-input"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                showLabel={lang === 'pt' ? 'Mostrar senha' : 'Show password'}
                hideLabel={lang === 'pt' ? 'Ocultar senha' : 'Hide password'}
              />
              <button className="lp-btn" type="submit" disabled={loading}>{loading ? tx.entrando : tx.entrar}</button>
            </form>

            <button
              type="button"
              onClick={() => { setModo('recuperar'); setError(''); setRecMsg(null); }}
              style={{ display:'block', margin:'16px auto 0', background:'transparent', border:'none', color:'var(--text-2)', fontSize:'12px', cursor:'pointer', fontFamily:"'Inter',sans-serif" }}
            >
              {tx.esqueciSenha}
            </button>

            {isLocalDev && (
              <div style={{ marginTop:'22px', paddingTop:'18px', borderTop:'1px solid var(--divider)' }}>
                <div style={{ fontSize:'10px', fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:'var(--text-2)', textAlign:'center', marginBottom:'10px' }}>
                  Acesso local para teste
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
                  <button type="button" onClick={() => handleDemo('aluna')} style={{ padding:'11px 10px', border:'1.5px solid var(--divider)', borderRadius:'var(--r-btn)', background:'var(--surface)', color:'var(--text)', fontSize:'12px', fontWeight:700, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
                    Ver como aluna
                  </button>
                  <button type="button" onClick={() => handleDemo('admin')} style={{ padding:'11px 10px', border:'1.5px solid var(--divider)', borderRadius:'var(--r-btn)', background:'var(--surface)', color:'var(--text)', fontSize:'12px', fontWeight:700, cursor:'pointer', fontFamily:"'Inter',sans-serif" }}>
                    Ver como admin
                  </button>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div style={{ fontSize:'13px', color:'var(--text-2)', marginBottom:'20px', textAlign:'center', lineHeight:1.6 }}>
              {tx.recSubtitle}
            </div>

            {recMsg && (
              <div style={{ padding:'11px 13px', background:'rgba(76,175,80,0.08)', border:'1px solid rgba(76,175,80,0.25)', color:'#2E7D32', borderRadius:'var(--r-btn)', fontSize:'13px', marginBottom:'16px' }}>
                {recMsg}
              </div>
            )}

            <form onSubmit={handleRecuperar}>
              <label className="lp-label">{tx.email}</label>
              <input className="lp-input" type="email" value={recEmail} onChange={e => setRecEmail(e.target.value)} placeholder="seu@email.com" required />
              <button className="lp-btn" type="submit" disabled={recLoading}>{recLoading ? tx.enviando : tx.enviarLink}</button>
            </form>

            <button
              type="button"
              onClick={() => { setModo('login'); setRecMsg(null); }}
              style={{ display:'block', margin:'16px auto 0', background:'transparent', border:'none', color:'var(--text-2)', fontSize:'12px', cursor:'pointer', fontFamily:"'Inter',sans-serif" }}
            >
              {tx.voltarLogin}
            </button>
          </>
        )}

      </div>
    </div>
  );
}
